import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

type Props = {
    url: string;
    name: string;
};

export function ReportUrl(props: Props) {
    return (
        // @ts-expect-error
        <Link className='link-report' size='small' as={RouterLink} to={props.url}>
            <div className='icon' /> Report on {props.name}
        </Link>
    );
}
